import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body,
  html {
    font-family: "Pretendard", sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    letter-spacing: -0.5px;
    height: 100%;
    overflow: auto;
  }

  #root {
    height: 100%;
  }

  .app-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .content-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
    height: calc(100vh - 60px);
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }

    .content-container {
      padding: 10px;
      height: calc(100vh - 50px);
    }
  }

  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

`;

export default GlobalStyle;
